module.exports = __webpack_public_path__ + "media/images/ic-quote-left-e66f39cb088ac05390f389a5834cfc4e.svg";